export class FcdVersion {
  constructor(
    public readonly id: number,
    public readonly retrieveDate: Date,
    public readonly mapId: number,
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/fcdversion.model.ts